import { isWiseUiEnabled } from 'config/wiseUi';

import LegacyProductsBox from 'components/containers/ProductsBox/ProductsBox';
import WiseProductsBox from 'components/wise/WiseProductsBox/WiseProductsBox';

const ProductsBox = isWiseUiEnabled() ? WiseProductsBox : LegacyProductsBox;

export default ProductsBox;
